import _ from 'lodash'
import { GetterTree } from 'vuex';
import { StudentsState } from '@/store/students/types';
import { RootState } from '@/store/types';

const getters : GetterTree<StudentsState, RootState> = {
  /**
   * 履修者IDを使って履修者詳細を取得
   * @param {string} tutorId 履修者ID
   */
  findStudentById: (state) => (id: string) => _.find(state.students, { id }),

  /**
   * 履修者のコース受講履歴を取得
   * @parma {{
   *  studentId: string, // 履修者ID
   *  courseHistoryId: string, // コース履歴ID
   * }}
   */
  findStudentCourseGrades: (state) => (
    { studentId, courseHistoryId }: { studentId: string, courseHistoryId: string },
  ) => _.chain(state.courseGrades)
    .find({ studentId, courseHistoryId })
    .get('courseGrade')
    .value(),
};

export default getters;
